export enum LiveChannelRowCardsCount {
  DEFAULT = 10,
  SEARCH_PAGE = 36,
}
